import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Interruptor del Nervio Vago',
    items: ['Frenás el espasmo en 3 minutos, incluso en público.', 'Tu cuerpo aprende a calmarse solo ante el primer síntoma.', 'Nunca más te quedás paralizada sin saber qué hacer.', 'El silencio llega desde la primera aplicación.', 'Sin pastillas. Sin esperar. Desde hoy.'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Arquitectura del Masaje Visceral',
    items: ['Soltás los gases atrapados con tus manos en minutos.', 'La panza dura empieza a ablandarse desde el primer día.', 'Detectás dónde está la tensión antes de que se convierta en dolor.', 'Cinco minutos que reemplazan una pastilla.', 'Lo hacés sola, en tu casa, cuando lo necesitás.'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — Blindaje Social y Preventivo',
    items: ['Salís a comer sin el miedo de "no sé cómo voy a terminar".', 'Asado, pizza, restaurant: un protocolo para cada situación.', 'Pedís en cualquier mesa sin dar explicaciones a nadie.', 'Dejás de elegir dónde vas según si tiene baño cerca.', 'Recuperás la vida social que la panza te fue sacando.'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Farmacia Natural y Dietética Local',
    items: ['Las hierbas de la feria que calman el fuego interno en 15 minutos.', 'Sin suplementos caros ni productos que no conseguís en Argentina.', 'Sabés exactamente qué pedir y cómo prepararlo.', 'Tu botiquín digestivo completo por menos de lo que gastás en pastillas.', 'Herramientas naturales que funcionan cuando más las necesitás.'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — El Detector de Crisis y Futuro',
    items: ['Descubrís en 2 minutos qué disparó el malestar de hoy.', 'Dejás de adivinar y empezás a prevenir antes de que empiece.', 'Volvés a comer lo que te daba miedo, sin el miedo.', 'El silencio deja de ser suerte y pasa a ser sistema.', 'Tu hoja de ruta para los próximos 90 días sin recaídas.'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para arrancar hoy mismo', 'Recetas y preparaciones paso a paso', 'Herramientas para cualquier situación social', 'Tracker de síntomas + criterios de medición', 'Errores frecuentes y cómo evitarlos', 'Checklist imprimible por etapa', '100% adaptado a la mujer argentina'];
  return <section className="py-24 bg-brand-dark" data-id="element-222">
      <div className="container mx-auto px-4" data-id="element-223">
        <div className="max-w-5xl mx-auto" data-id="element-224">
          <div className="text-center mb-16" data-id="element-225">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-226">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-227">
                SISTEMA SILENCIO ABDOMINAL™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-228">
                5 Tomos + 5 Bonos · Protocolo de Alivio Inmediato
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-229">
            📚 LOS 5 TOMOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-230">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-231">
                <div className="text-5xl shrink-0" data-id="element-232">{tomo.emoji}</div>
                <div data-id="element-233">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-234">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-235">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-236">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-237" />
                        <span data-id="element-238">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-239">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-240">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-241">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-242">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-243" />
                  <span className="text-gray-200" data-id="element-244">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}